import React, { Component } from 'react'
import AirPlaneHostIcon from 'assets/icons/ico-airplane-host.png'
// import CloneHostIcon from 'assets/icons/ico-clone-host.png'
import DeleteHostIcon from 'assets/icons/ico-delete-host.png'
import EditHostIcon from 'assets/icons/ico-edit-host.png'
import AppleIconWhite from 'assets/icons/apple-icon-white.png'
// import SettingHostIcon from 'assets/icons/ico-setting-host.png'
import SendUpdate from './SendUpdate/SendUpdate'
import { showSendUpdateModal } from 'src/actions/frontend'
import { deleteEvent, cloneEvent } from 'src/actions/event'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { routerActions } from 'react-router-redux'
import { parseEventUrl } from 'services/url_helpers'
import { flyerDesignLayoutConfig } from 'src/assets/frontend-json/flyer-position'
import HobnobModal from 'components/common/HobnobModal'
import LogoRectangle from 'assets/icons/logo-rectangle.png'
import Button from 'src/components/common/Button'
import { appUrl } from 'src/containers/time-poll/constants'
import styles from './host-option.scss'

class HostOption extends Component {
  state = {
    isOpenDownload: false
  }

  handleCloneEvent = () => {
    const { onCloneEvent, event } = this.props
    onCloneEvent({
      eventId: event.id,
      onSuccessCallback: data => {
        location.href = data.event.url
      }
    })
  }

  handleDeleteEvent = () => {
    const { onDeleteEvent, event, onChangeRouter } = this.props

    onDeleteEvent({
      eventId: event.id,
      onSuccessCallback: () => {
        onChangeRouter('/e/list')
      }
    })
  }

  goEditEvent = () => {
    const designNumbers = flyerDesignLayoutConfig.map(design => design.designIds).reduce((a, b) => a.concat(b), [])

    const {
      onChangeEditRouter,
      event: {
        flyer: { design_number }
      }
    } = this.props

    if (designNumbers.indexOf(Number(design_number)) > -1) {
      const { eventToken } = parseEventUrl(location.pathname)
      onChangeEditRouter(eventToken)
    } else {
      this.setState({ isOpenDownload: true })
    }
  }

  render() {
    const { event, onShowSendUpdateModal } = this.props
    const { isOpenDownload } = this.state

    return (
      <div className={styles['host-option-container']}>
        <h3 className={styles['host-option-title']}>host options</h3>
        <div className={styles['icon-container']}>
          <div
            className={cn(styles['icon-wrapper'], {
              [styles['icon-wrapper-hidden']]:
                (event.feature_level < 1 && !event.grandfathered) || event.state === 'draft'
            })}
            onClick={onShowSendUpdateModal}
          >
            <img src={AirPlaneHostIcon} width="30" />
            <div className={styles['icon-label']}>send update</div>
          </div>
          <div className={styles['icon-wrapper']} onClick={this.goEditEvent}>
            <img src={EditHostIcon} width="30" />
            <div className={styles['icon-label']}>edit event</div>
          </div>
          {/* <div
            className={cn(styles['icon-wrapper'], {
              [styles['icon-wrapper-hidden']]: event.state === 'draft'
            })}
            onClick={this.handleCloneEvent}
          >
            <img src={CloneHostIcon} width="30" />
            <div className={styles['icon-label']}>clone event</div>
          </div> */}
          {/* <div className={styles['icon-wrapper']}>
            <img src={SettingHostIcon} width="30" />
            <div className={styles['icon-label']}>event settings</div>
          </div> */}
          <div className={styles['icon-wrapper']} onClick={this.handleDeleteEvent}>
            <img src={DeleteHostIcon} width="30" />
            <div style={{ color: '#d0021b' }} className={styles['icon-label']}>
              delete event
            </div>
          </div>
        </div>

        <SendUpdate event={event} />
        <HobnobModal
          containerClassName={styles['hobnob-container']}
          onClose={() => this.setState({ isOpenDownload: false })}
          show={isOpenDownload}
          showCancelIcon={false}
        >
          <div className={styles['modal-wrapper']}>
            <div className={styles['img-inner']}>
              <img src={LogoRectangle} alt="" />
            </div>
            <div className={styles['content-container']}>
              <div className={styles['text']}>
                Create and send invites for your own event for free!
              </div>

              <Button wrapperElement={'a'} className={styles['button-inner']} href={appUrl}>
                <img src={AppleIconWhite} alt="" width="30" />
                <span>Download App on App Store</span>
              </Button>

              <div
                className={styles['thx-text']}
                onClick={() => this.setState({ isOpenDownload: false })}
              >
                no, thanks
              </div>
            </div>
          </div>
        </HobnobModal>
      </div>
    )
  }
}

HostOption.propTypes = {
  event: PropTypes.object,
  onShowSendUpdateModal: PropTypes.func,
  onDeleteEvent: PropTypes.func,
  onCloneEvent: PropTypes.func,
  onChangeRouter: PropTypes.func,
  onChangeEditRouter: PropTypes.func
}

function mapDispatchToState(dispatch) {
  return {
    onShowSendUpdateModal: () => dispatch(showSendUpdateModal()),
    onDeleteEvent: params => dispatch(deleteEvent(params)),
    onCloneEvent: params => dispatch(cloneEvent(params)),
    onChangeRouter: params => dispatch(routerActions.replace(params)),
    onChangeEditRouter: token => dispatch(routerActions.push('/e/edit/' + token))
  }
}

export default connect(null, mapDispatchToState)(HostOption)



// WEBPACK FOOTER //
// ./src/components/details/HostOption/HostOption.jsx